import { useEffect } from 'react';
import { useIntl } from 'react-intl';

const HeadConfigurer = () => {
  const intl = useIntl();

  useEffect(() => {
    document.title = intl.formatMessage({ id: 'header.registration.title' });
  }, [intl]);

  return null;
};

export default HeadConfigurer;
